import { createSlice } from "@reduxjs/toolkit";
import { getAvailableAccess } from "../Actions/action";


export const AllAvailableAccess = createSlice({
    name: "service",
    initialState: {
        AllAvailableAccessList: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAvailableAccess?.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAvailableAccess?.fulfilled, (state, action) => {
                state.isLoading = false;
                state.AllAvailableAccessList = action?.payload?.data?.result;
            })
            .addCase(getAvailableAccess?.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action?.error?.message;
            })
    }
})

export default AllAvailableAccess.reducer;